import React from 'react';

const TeamPage: React.FC = () => {
    return (
        <div>
            TeamPage
        </div>
    );
};

export { TeamPage }
